import { useLocation, Link } from "react-router-dom";

const PaymentSuccess = () => {
  const query = new URLSearchParams(useLocation().search);
  const txnid = query.get("txnid");

  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h1>🎉 Payment Successful</h1>
      <p>Your booking has been confirmed.</p>
      <p>Transaction ID: {txnid}</p>
      <Link to="/">Go to Home</Link>
    </div>
  );
};

export default PaymentSuccess;